import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { from, Observable, pluck } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<string> {
    return from(import(`../assets/i18n/${lang}.ts`)).pipe(pluck('default'));
  }
}

export function httpTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
